/**
 * Naše a původní funkce pro ajax volání převzaty od OC4
 */

class Chain {
    constructor() {
        this.start = false;
        this.data = [];
    }

    attach(call) {
        this.data.push(call);

        if (!this.start) {
            this.execute();
        }
    }

    execute() {
        if (this.data.length) {
            this.start = true;

            var call = this.data.shift();

            var jqxhr = call();

            jqxhr.done(function () {
                chain.execute();
            });
        } else {
            this.start = false;
        }
    }
}



var chain = new Chain();

const ajaxJquery = window.jQuery;

if (ajaxJquery) {
    (function ($) {
    const handleAjaxRedirect = function (redirect) {
        if (Array.isArray(redirect)) {
            redirect.forEach(function (item, index) {
                setTimeout(function () {
                    if (item === '_self') {
                        window.PreventLeaveNavigate(item);
                        return;
                    }

                    window.open(item, '_blank');
                }, index * 400);
            });

            return;
        }
        window.PreventLeaveNavigate(redirect);
    };

    const pushReadableHistoryUrl = function(link) {
        if (!link || typeof link !== 'string') {
            return;
        }

        let newUrl = link.trim();

        if (!newUrl.startsWith('http') && !newUrl.startsWith('?')) {
            newUrl = '?' + newUrl;
        }

        try {
            newUrl = decodeURIComponent(newUrl);
        } catch (e) {
            console.log(e);
            // Pokud je vstup rozbitě zakódovaný, ponechá se původní hodnota.
        }

        window.history.pushState(null, '', newUrl);
    }

    const getManagedForms = function (form) {
        const forms = [form];

        if (form.dataset.formJoin) {
            const joinedForm = document.querySelector(form.dataset.formJoin);
console.log(joinedForm);
            if (joinedForm && !forms.includes(joinedForm)) {
                forms.push(joinedForm);
            }
        }

        return forms;
    };

    const clearFormFields = function (form) {
        Array.from(form.elements || []).forEach(function (field) {
            if (!field.name || field.disabled || field.type === 'submit' || field.type === 'button' || field.type === 'reset') {
                return;
            }

            if (field.tomselect) {
                field.tomselect.clear(true);
                return;
            }

            if (field.tagName === 'SELECT' && field.multiple) {
                Array.from(field.options).forEach(function (option) {
                    option.selected = false;
                });
            } else if (field.type === 'checkbox' || field.type === 'radio') {
                field.checked = false;
            } else {
                field.value = '';
            }

            field.dispatchEvent(new Event('change', { bubbles: true }));
        });
    };

    const clearAjaxForms = function (form) {
        getManagedForms(form).forEach(function (managedForm) {
            clearFormFields(managedForm);
        });
    };

    $(document)
        .on('change', 'form[data-wp-form="submitOnChange"] input, form[data-wp-form="submitOnChange"] select', function (e) {
            const $input = $(this);
            const $form  = $input.closest('form');
            const isDate = $input.is('input[type="date"], input[type="datetime-local"], input[type="month"], input[type="week"], input[type="time"]');

            if (isDate) {
                // Zruš předchozí timer pro tento konkrétní input
                clearTimeout($input.data('submitTimer'));
                $input.data('submitTimer', setTimeout(function () {
                    $form.trigger('submit');
                }, 600));
            } else {
                $form.trigger('submit');
            }
        })
        .on('click', 'a[data-wp-toggle="ajax"]', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();

            var element = this;

            if ($(element).data('loading')) {
                return;
            }

            $.ajax({
                url: $(element).attr('href'),
                type: 'get',
                dataType: 'json',
                beforeSend: function () {
                    $(element).data('loading', true);

                    if ($(element).hasClass('btn')) {
                        toggleButtonLoading(element, true);
                    }
                },
                complete: function () {
                    $(element).removeData('loading');

                    if ($(element).hasClass('btn')) {
                        toggleButtonLoading(element, false);
                    }

                    $('body').tooltip('dispose');
                },
                success: function (json) {
                    console.log(json);

                    $('.alert-dismissible').remove();

                    if (json?.success) {
                        if (json?.data?.message) {
                            $('#alert').append(
                                '<div class="alert alert-success alert-dismissible">' +
                                '<i class="fa-solid fa-circle-check"></i> ' + json.data.message +
                                '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                                '</div>'
                            );
                        }

                        if (json?.data?.success) {
                            $('#alert').append(
                                '<div class="alert alert-success alert-dismissible">' +
                                '<i class="fa-solid fa-circle-check"></i> ' + json.data.success +
                                '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                                '</div>'
                            );
                        }

                        if (typeof json.data.modal === 'undefined' && typeof json.data.modal_url=== 'undefined' && typeof json.data.modal_replace_url=== 'undefined') {
                            ModalManager.close();
                        }
                    } else {
                        if (typeof json?.data?.message === 'string') {
                            $('#alert').append(
                                '<div class="alert alert-danger alert-dismissible">' +
                                '<i class="fa-solid fa-circle-exclamation"></i> ' + json.data.message +
                                '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                                '</div>'
                            );
                        }

                        if (json?.data?.warning) {
                            $('#alert').append(
                                '<div class="alert alert-warning alert-dismissible">' +
                                '<i class="fa-solid fa-circle-exclamation"></i> ' + json.data.warning +
                                '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                                '</div>'
                            );
                        }
                    }
                    if (json?.data?.error) {
                        $('#alert').append(
                            '<div class="alert alert-danger alert-dismissible">' +
                            '<i class="fa-solid fa-circle-exclamation"></i> ' + json.data.error +
                            '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                            '</div>'
                        );
                    }
                    if (json?.data?.link) {
                        pushReadableHistoryUrl(json.data.link);
                    }

                    if (json?.data?.redirect) {
                        handleAjaxRedirect(json.data.redirect);
                    }

                    if (json?.data?.modal) {
                        ModalManager.open(json.data.modal, false);
                    } else if (json?.data?.modal_url) {
                        ModalManager.open(json.data.modal_url, true);
                    } else if(json?.data?.modal_replace_url) {
                        ModalManager.replace(json.data.modal_replace_url, true);
                    } else if(json?.data?.modal_replace) {
                        ModalManager.replace(json.data.modal_replace, false);
                    }

                    // Aktualizace cílového prvku
                    if ($(element).data('wp-load')) {
                        $($(element).data('wp-target')).load($(element).data('wp-load'));
                    } else if ($(element).data('wp-target') && (typeof json.data?.html === 'string')) {
                        $($(element).data('wp-target')).html(json.data.html);
                    } else if ($(element).data('wp-target')) {
                        $($(element).data('wp-target')).html(json);
                    }
                },
                error: function (xhr, status, error) {
                    $('#alert').append(
                        '<div class="alert alert-danger alert-dismissible">' +
                        '<i class="fa-solid fa-circle-exclamation"></i> Chyba spojení se serverem: ' + error +
                        ' <button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                        '</div>'
                    );
                }
            }).always(function () {
                toggleButtonLoading(element, false);
            });
        })
        .on('click', '[data-wp-toggle="load"]', function (e) {

            e.stopImmediatePropagation();
            e.preventDefault();

            var $element = $(this);
            var $target = $($element.data('wp-target'));
            var loadUrl = $element.data('wp-load') || $element.prop('href') || '';
            loadUrl = loadUrl.replace(/\\3e/g, '>');

            if (loadUrl) {
                $target.load(loadUrl);
            }


        })
        .on('submit', 'form', function (e) {
            var element = this;
            var button = (e.originalEvent !== undefined && e.originalEvent.submitter !== undefined) ? e.originalEvent.submitter : '';

            if ($(element).attr('data-wp-toggle') == 'ajax' || $(button).attr('data-wp-toggle') == 'ajax') {
                e.preventDefault();

                var form = e.target;

                var processedNames = {};

                if(form.dataset.preventLeave){
                    window.PreventLeaveReset(form.dataset.preventLeave);
                }


                var action = $(button).attr('formaction') || $(form).attr('action');
                var method = $(button).attr('formmethod') || $(form).attr('method') || 'post';
                var enctype = $(button).attr('formenctype') || $(form).attr('enctype') || 'application/x-www-form-urlencoded';

                var formData = new FormData(form);

                var appendFormDataset = function (sourceForm) {
                    Object.entries(sourceForm.dataset).forEach(function ([key, value]) {
                        formData.append('attr_' + key, value);
                    });
                };

                var appendJoinedForm = function (selector) {
                    var joinedForm = document.querySelector(selector);

                    if (!joinedForm || joinedForm === form) {
                        return;
                    }

                    var joinedFormData = new FormData(joinedForm);

                    joinedFormData.forEach(function (value, key) {
                        formData.append(key, value);
                    });

                    appendFormDataset(joinedForm);
                };

                appendFormDataset(form);
                if (button && $(button).attr('name')) {
                    formData.append($(button).attr('name'), $(button).val());
                }


                if(form.dataset.formJoin){
                    appendJoinedForm(form.dataset.formJoin);
                }

                console.log(e);
                console.log(element);
                console.log('action ' + action);
                console.log('button ' + button);
                console.log('method ' + method);
                console.log('enctype ' + enctype);
                console.log($(element).serialize());

                $.ajax({
                    url: action.replaceAll('&amp;', '&'),
                    type: method,
                    data: formData,
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        toggleButtonLoading(button, true);
                    },
                    success: function (json, textStatus) {
                        console.log(json);
                        console.log(textStatus);

                        $('.alert-dismissible').remove();
                        $(element).find('.is-invalid').removeClass('is-invalid');
                        $(element).find('.invalid-feedback').removeClass('d-block');

                        if (json['success']) {
                            element.dispatchEvent(new CustomEvent('wp-ajax:success', { bubbles: true, detail: json }));
                            window.onbeforeunload = null;
                            // Refresh
                            var url = $(form).attr('data-wp-load');
                            var target = $(form).attr('data-wp-target');

                            if (url !== undefined && target !== undefined) {
                                $(target).load(url)
                            }
                            if (typeof json.data.modal === 'undefined' && typeof json.data.modal_replace === 'undefined' && typeof json.data.modal_url === 'undefined' && typeof json.data.modal_replace_url === 'undefined') {
                                ModalManager.close();
                            }

                            if (json['data']) {
                                if (json['data']['message']) {
                                    $('#alert').prepend('<div class="alert alert-success alert-dismissible"><i class="fa-solid fa-circle-check"></i> ' + json['data']['message'] + ' <button type="button" class="btn-close" data-bs-dismiss="alert"></button></div>');
                                }
                                if (json?.data?.redirect) {
                                    handleAjaxRedirect(json.data.redirect);
                                }
                                if (Object.prototype.hasOwnProperty.call(json.data, 'filter') && json.data.filter === null) {
                                    clearAjaxForms(form);
                                }
                                if (json['data']['link']) {
                                    pushReadableHistoryUrl(json['data']['link']);
                                }
                                if(target !== undefined && json['data']['html'] !== undefined) {
                                    $(target).replaceWith(json['data']['html']);
                                }
                                if (json['data']['modal']) {
                                    ModalManager.open(json['data']['modal'], false);
                                } else if (json['data']['modal_url']) {
                                    ModalManager.open(json['data']['modal_url'], true);
                                } else if(json['data']['modal_replace_url']) {
                                    ModalManager.replace(json['data']['modal_replace_url'], true);
                                } else if(json['data']['modal_replace']) {
                                    ModalManager.replace(json['data']['modal_replace_url'], false);
                                }
                            }
                        } else {
                            element.dispatchEvent(new CustomEvent('wp-ajax:error', { bubbles: true, detail: json }));
                            if (typeof json['data']['message'] == 'string') {
                                $('#alert').prepend('<div class="alert alert-danger alert-dismissible"><i class="fa-solid fa-circle-exclamation"></i> ' + json['data']['message'] + ' <button type="button" class="btn-close" data-bs-dismiss="alert"></button></div>');
                            }

                            if (typeof json['data']['error'] == 'object') {
                                if (json['data']['warning']) {
                                    $('#alert').prepend('<div class="alert alert-danger alert-dismissible"><i class="fa-solid fa-circle-exclamation"></i> ' + json['data']['warning'] + ' <button type="button" class="btn-close" data-bs-dismiss="alert"></button></div>');
                                }

                                for (var key in json['data']['error']) {
                                    $('#input-' + key.replaceAll('_', '-'))
                                        .addClass('is-invalid')
                                        .next('.ts-wrapper').addClass('is-invalid')
                                        .end()
                                        .find('.form-control, .form-select, .form-check-input, .form-check-label').addClass('is-invalid');
                                    $('#error-' + key.replaceAll('_', '-')).html(json['data']['error'][key].replace(/\n/g, '<br>')).addClass('d-block');
                                }
                            }
                        }

                        // Replace any form values that correspond to form names.
                        for (var key in json['data']) {
                            $(element).find('[name=\'' + key + '\']').val(json['data'][key]);
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                        element.dispatchEvent(new CustomEvent('wp-ajax:error', { bubbles: true, detail: xhr }));
                    }
                }).always(function () {
                    toggleButtonLoading(button, false);
                });
            }
        })
        $('[data-wp-toggle="ajax"]').attr('novalidate', true);

        window.pushReadableHistoryUrl = pushReadableHistoryUrl;
    })(ajaxJquery);

} else {
    console.warn('[ajax] jQuery is not available, skipping ajax bindings.');
}
